module.exports = __webpack_public_path__ + "static/don20-f3954e9a51c5c00007a5364c60f7f18b.jpg";